/* eslint-disable */
// ####################################+################################################
// ################# THIS IS GENERATED FILE DO NOT TOUCH!!!!!!!!!!!!####################
// ####################################-################################################
import type * as Types from '../packlets/generated'

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'
export type UserReferralFragmentFragment = {
  __typename?: 'UserReferral'
  id: string
  code: string
  creditCurrencyCode: Types.CurrencyCode
  creditCents: number
  percentageOff: number
}

export type GetSelfUserReferralQueryVariables = Types.Exact<{
  [key: string]: never
}>

export type GetSelfUserReferralQuery = {
  __typename?: 'Query'
  getSelfUserReferral?:
    | {
        __typename?: 'UserReferral'
        id: string
        code: string
        creditCurrencyCode: Types.CurrencyCode
        creditCents: number
        percentageOff: number
      }
    | null
    | undefined
}

export type GetSelfUserReferralMetaQueryVariables = Types.Exact<{
  [key: string]: never
}>

export type GetSelfUserReferralMetaQuery = {
  __typename?: 'Query'
  getSelfUserReferralMeta: {
    __typename?: 'GetUserReferralMetaResponse'
    totalRedeemedReferralsCount: number
    creditBalanceCents: number
    creditBalanceCurrencyCode: Types.CurrencyCode
  }
}

export const UserReferralFragmentFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserReferralFragment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'UserReferral' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'code' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'creditCurrencyCode' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'creditCents' } },
          { kind: 'Field', name: { kind: 'Name', value: 'percentageOff' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UserReferralFragmentFragment, unknown>
export const GetSelfUserReferralDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetSelfUserReferral' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getSelfUserReferral' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'UserReferralFragment' },
                },
              ],
            },
          },
        ],
      },
    },
    ...UserReferralFragmentFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<
  GetSelfUserReferralQuery,
  GetSelfUserReferralQueryVariables
>
export const GetSelfUserReferralMetaDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetSelfUserReferralMeta' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getSelfUserReferralMeta' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'totalRedeemedReferralsCount' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'creditBalanceCents' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'creditBalanceCurrencyCode' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetSelfUserReferralMetaQuery,
  GetSelfUserReferralMetaQueryVariables
>
